import {
  Button,
  Divider,
  Input,
  Modal,
  Row,
  Spin,
  Table,
  Tooltip,
  message
} from 'antd'
import axios from 'axios'
import React, { Component } from 'react'
import { FormattedMessage } from "react-intl"
import { IconTray } from '../../../components/CustomReturnsIcons'
import '../../../styles/Visitor.css'
import { debounce } from 'lodash';
const { Search } = Input

class StoreWideProducts extends Component {
  constructor(props) {
    super(props)
    this.state = {
      products: [],
      loading: true,
      searchValue: undefined,
      shopCurrency: null,
      modalProducts: [],
      storeWideOverselling: false,
      expandedRowId:"",
      hasNextPage: true,
      endCursor: null,
      currentPage: 1,
      searchProducts: [],
    }
    this.debounceSearchProducts = debounce(this.searchedProducts, 1000);
  }

  async componentDidMount() {
    try {
      const { companyIdentifier, returnNumber, currentProduct, returnSettings, isMerchantDashboard, currency } = this.props;
      const url = isMerchantDashboard ? '/api/returns/getStoreWideProducts' : '/api/visitors/return/getProducts'
      const productsResponse = await axios.post(url,{companyIdentifier,returnNumber})

      if (productsResponse.status !== 200 || !productsResponse.data?.products?.length) {
        throw new Error('Error while getting products from Shopify');
      }
      // Attach the image with variant object

      const products = productsResponse.data.products;
      const shopCurrency = currentProduct?.price_set?.shop_money?.currency_code || currency;
      const hasNextPage = productsResponse.data?.hasNextPage;
      const endCursor = productsResponse.data?.endCursor;
      this.setState({
        products,
        modalProducts: products,
        loading: false,
        shopCurrency,
        storeWideOverselling: returnSettings.storeWideOverselling,
        hasNextPage,
        endCursor,
      });
  
      const { exchangesEnableHighPriced } = returnSettings;
      if (!exchangesEnableHighPriced && !this.props.isMerchantDashboard) {
        const currentPrice = parseInt(currentProduct?.price_set?.shop_money?.amount || currentProduct?.price, 10);
        const exchangeableProducts = products.filter(product => {
          product.variants = product.variants.filter(variant => parseInt(variant.price, 10) <= currentPrice)
          return product.variants.length > 0 ? true : false;
        });
        this.setState({
          products: exchangeableProducts,
          modalProducts: exchangeableProducts,
        });
      }
      document.querySelector(".ant-modal-body")?.addEventListener('touchmove', (e) => {
        document.activeElement.blur();
      });
      return this.props.history?.push('/return/order?storeWideExchanges=true');
    } catch (error) {
      console.error('Error:', error);
      message.error('Error occurred during data retrieval', 4);
      this.setState({
        loading: false,
      });
    }
  }

  componentWillUnmount() {
    if (this.props.location?.search) return this.props?.history.goBack();
  }

  handleSearchChange = async (e) => {
    try {
      const value = e.target.value;
      this.setState ({
        searchValue: value,
      })
      if (value) {
        await this.debounceSearchProducts(value);
        return;
      }
      this.setState({
        modalProducts: this.state.products
      });
    } catch (err) {
      message.error('Something went wrong while searching for products', 4);
      this.setState({
        loading: false,
      });
    }
  };

  searchedProducts = async (searchValue) => {
    try {
      this.setState ({
        loading: true,
      })
      const { companyIdentifier, isMerchantDashboard, returnNumber } = this.props;
      const url = isMerchantDashboard ? '/api/returns/getSearchProducts' : '/api/visitors/return/getSearchProducts';
      const searchResponse = await axios.post(url,{companyIdentifier, returnNumber, searchValue});
      const searchProducts = searchResponse.data.products;
      this.setState({
        searchProducts,
        modalProducts: searchProducts,
        loading: false,
      });
    } catch (err) {
      message.error('Something went wrong while searching for products', 4);
      this.setState({
        loading: false,
      });
    }
  }

  handleResetSearch = () => {
    this.setState({
      searchValue: '',
      modalProducts: this.state.products,
    })
  }
  
  handleSelectedVariant = (record) => {
    const { modalProducts } = this.state;
    const selectedProduct = modalProducts.find((product) => product.id === record.product_id);
    if (selectedProduct) {
      selectedProduct.selectedVariant = record;
      this.props.handleSelectedProduct(selectedProduct)
      this.props.hideProducts(record)
    }
  };
  
  handleRowExpansion = (id) => {
    if (this.state.expandedRowId === id) {
      this.setState({ expandedRowId: undefined });
    } else {
      this.setState({ expandedRowId: id });
    }
  }

  handleBalanace = (price) => {
    if (this.props?.returnSettings?.storeWideBalance) return '';
    let currentPriceAfterDiscount = this.props.currentProduct?.price;
    let discount = this.props?.isMerchantDashboard ? 
      this.props.currentProduct?.discount
      :
      this.props.currentProduct?.discount_allocations && this.props.currentProduct?.discount_allocations[0]?.amount_set?.shop_money?.amount

    if (this.props?.returnSettings?.storeWideDiscount && discount) {
      currentPriceAfterDiscount = currentPriceAfterDiscount - discount;
    }
    
    return (currentPriceAfterDiscount - price) > 0 ? 
      <span className='positiveBalanceText' style={{ textAlign: 'left' }}>{`You’re getting: ${(currentPriceAfterDiscount - price).toFixed(2)} ${this.state.shopCurrency}`}</span>
      :
      <span className='negativeBalanceText' style={{ textAlign: 'left' }}>{`Left to pay: ${(price - currentPriceAfterDiscount).toFixed(2)} ${this.state.shopCurrency}`}</span>
  }

  handleLowStockRule = (tags, variant) => {
    let lowStock = false;
    const currentProductQuantity = this.props?.isMerchantDashboard ?
      this.props?.currentProduct.quantity
      :
      this.props.itemQuantity[`quantity_${this.props.currentProduct?.variant_id}`];
    const quantityCheck = variant.inventory_quantity < currentProductQuantity;
    if (this.props?.returnSettings?.inventoryStock) {

      const reserveStockFields = this.props?.returnSettings?.reserveStockFields;
      const variantExist = reserveStockFields?.find(field => field.variantId === variant.id);
      const tagExist = reserveStockFields?.find(field => field.type === "Tag" && field.title.some(tag => tags.includes(tags)));
      if (variantExist && tagExist) {
        const quantity = variantExist.quantity > tagExist.quantity ? variantExist.quantity :  tagExist.quantity;
        lowStock = variant.inventory_quantity < quantity;
      } else if (variantExist) {
        lowStock = variant.inventory_quantity < variantExist.quantity;
      } else if (tagExist) {
        lowStock = variant.inventory_quantity < tagExist.quantity;
      }

      return ( lowStock || quantityCheck );
    }
    return lowStock;
  }

  handlePageChange = async (currentPage, pageSize) => {
    try {
      const totalProducts = this.state.products;
      const lastPage = currentPage === Math.ceil(totalProducts?.length / pageSize);
      const hasNextPage = this.state.hasNextPage;
      const endCursor = this.state.endCursor;
      if (lastPage && hasNextPage && endCursor) {
        this.setState ({
          loading: true,
        });
        const { companyIdentifier, returnNumber, isMerchantDashboard} = this.props;
        const url = isMerchantDashboard ? '/api/returns/getStoreWideProducts' : '/api/visitors/return/getProducts';
        const productsResponse = await axios.post(url,{companyIdentifier,returnNumber,hasNextPage,endCursor});

        if (productsResponse.status !== 200 || !productsResponse.data?.products?.length) {
          throw new Error('Error while getting products from Shopify');
        }

        const products = productsResponse.data.products;
        const updatedProducts = [...totalProducts,...products];
        this.setState({
          products: updatedProducts,
          modalProducts: updatedProducts,
          loading: false,
          hasNextPage: productsResponse.data?.hasNextPage,
          endCursor: productsResponse.data?.endCursor,
          currentPage,
        });
      }
      this.setState ({
        currentPage,
      })
      return;
    } catch (error) {
      message.error('Error occurred during data retrieval', 4);
      this.setState({
        loading: false,
      });
    }
  }

  handleRowRander = (row) => {
    const nestedColumns = [
      {
        title: 'Title',
        key: 'title',
        render: (record) => <p>{record?.title}</p>,
        width: 240,
      },
      {
        title: 'Image',
        key: 'image',
        render: (product) => (
          <img
            src={product?.image?.src}
            style={{
              maxWidth: '100%',
              maxHeight: '100px',
              width: 'auto',
              height: 'auto',
            }}
            alt="Image"
          />
        ),
        width: 200,
      },
      {
        title: 'Action',
        key: 'action',
        width: 190,
        render: (_, record) => {
          if (!this.props?.reserveInventory && !this.props?.warrantySelection) {
            const lowStock = this.handleLowStockRule(row.tags, record);
            return (record.inventory_quantity < 1 || lowStock) &&
            !this.state.storeWideOverselling ? (
                <div className='priceContainer'>
                  <Tooltip placement="bottom" title="Product is out of stock.">
                    <Button type="primary" disabled={true}> {record?.price} {this.state.shopCurrency} </Button>
                  </Tooltip>
                  {this.handleBalanace(record?.price)}
                </div>
              ) : (
                <div className='priceContainer'>
                  <Button type="primary" onClick={() => { this.handleSelectedVariant(record) }}>
                    {record?.price} {this.state.shopCurrency}
                  </Button>
                  {this.handleBalanace(record?.price)}
                </div>
              )
          } else if (this.props?.warrantySelection) {
            const products = this.state.modalProducts;
            const fields = this.props?.warrantyProducts;

            let isExist = false;
            if (fields?.length > 0) {
              isExist = fields.find(field => field.variantId === record.id)
            }
            return (
              <div className='priceContainer'>
                <Button 
                  type={isExist ? "secondary" : "primary"} 
                  onClick={() => { this.props.handleWarrantyProduct(products, record) }}
                  disabled={isExist}
                  style={{ width: 'fit-content' }}
                >
                  {isExist ? 'Selected' : 'Select'}
                </Button>
              </div>
            )
          } else {
            const products = this.state.modalProducts;
            const fields = this.props?.reserveStockFields;
            let isExist = false;
            if (fields?.length > 0) {
              isExist = fields.find(field => field.variantId === record.id)
            }
            return (
              <div className='priceContainer'>
                <Button 
                  type={isExist ? "secondary" : "primary"} 
                  onClick={() => { this.props.handleProductList(products, record) }}
                  disabled={isExist}
                  style={{ width: 'fit-content' }}
                >
                  {isExist ? 'Added' : 'Select'}
                </Button>
              </div>
            )
          }
        }
      },
    ]
    return (
      <Table
        rowKey={(record) => record.id}
        columns={nestedColumns}
        dataSource={row.variants}
        pagination={{ defaultPageSize: 5 }}
        locale={{
          emptyText: (
            <div className="flex-row flex-middle-xxs flex-center-xxs">
              <div className="flex-col-xxs-12">
                <IconTray size="md" />
              </div>
              <div>
                <p className="TextBody TextBody--xxxs">No Data</p>
              </div>
            </div>
          ),
        }}
        style={{ marginRight: 30, marginTop: 30, marginBottom: 30 }}
      />
    )
  }

  columns = [
    {
      title: 'Product',
      dataIndex: 'title',
      key: 'title',
      width: 240,
      render: (text, record) => (
        <span>
          {text}
          {record.variants.length === 1 && record.variants[0].title !=="Default Title" && ` (${record.variants[0].title})`}
        </span>
      ),
    },
    {
      title: 'Image',
      key: 'image',
      width:120,
      render: (product) => (
        <img
          src={product?.image?.src}
          style={{
            maxWidth: '100%',
            maxHeight: '100px',
            width: 'auto',
            height: 'auto',
          }}
          alt="Image"
        />
      ),
    },
    {
      title: <span>{this.props?.reserveInventory ? 'Action' : 'Price'}</span>,
      key: `${this.props?.reserveInventory ? 'Action' : 'Price'}`,
      width: 210,
      render: (product) => {
        const singleVariant = product.variants.length === 1
        if (!this.props?.reserveInventory && !this.props?.warrantySelection){
          const productPrices = product?.variants.map((variant) => variant?.price);
          const minPrice = Math.min(...productPrices).toFixed(2)
          const maxPrice = Math.max(...productPrices).toFixed(2)
          const outOfStock = singleVariant && product.variants[0].inventory_quantity < 1;
          const oversellingEnabled = this.state.storeWideOverselling;
          if (minPrice === maxPrice) {
            if (singleVariant) {
              const lowStock = this.handleLowStockRule(product.tags, product.variants[0]);
              if ((outOfStock || lowStock ) && !oversellingEnabled) {
                return <div className='priceContainer' style={{ justifyContent: 'flex-end'}}>
                  <Tooltip placement="bottom" title="Product is out of stock.">
                    <Button type="primary"  disabled={true} style={{ width: 'fit-content' }}> {minPrice} {this.state.shopCurrency}</Button>
                  </Tooltip>
                </div>
                
              } else {
                return <div className='priceContainer' style={{ justifyContent: 'flex-end'}}>
                  <Button type="primary" onClick={() => {this.handleSelectedVariant(product.variants[0])}} style={{ width: 'fit-content' }}>
                    {minPrice} {this.state.shopCurrency}
                  </Button>
                  {this.handleBalanace(minPrice)}
                </div>
              }
            } else {
              return <div className='priceContainer' style={{ justifyContent: 'flex-end'}}>
                <Button type="primary" onClick={() => {this.handleRowExpansion(product.id)}} style={{ width: 'fit-content' }}>
                  {minPrice} {this.state.shopCurrency}
                </Button>
              </div>
            }
          } else {
            return <div className='priceContainer' style={{ justifyContent: 'flex-end'}}>
              <Button type="primary" onClick={() => {{this.handleRowExpansion(product.id)}}} style={{ width: 'fit-content' }}>
                {minPrice} {this.state.shopCurrency} - {maxPrice} {this.state.shopCurrency}
              </Button>
            </div>
          }
        } else if (this.props?.warrantySelection) {
          const products = this.state.modalProducts;
          if (singleVariant) {
            const fields = this.props?.warrantyProducts;
            let isExist = false;
            if (fields?.length > 0) {
              isExist = fields.find(field => field.variantId === product.variants[0].id)
            }
            return <div className='priceContainer' style={{ justifyContent: 'flex-end'}}>
              <Button 
                type={isExist ? "secondary" : "primary"} 
                onClick={() => {this.props.handleWarrantyProduct(products, product.variants[0])}}
                disabled={isExist}
                style={{ width: 'fit-content' }}
              >
                {isExist ? 'Selected' : 'Select'}
              </Button>
            </div>
          } else {
            return <div className='priceContainer' style={{ justifyContent: 'flex-end'}}>
              <Button type="primary" onClick={() => {this.handleRowExpansion(product.id)}} style={{ width: 'fit-content' }}>
                Expand
              </Button>
            </div>
          }
        } else {
          const products = this.state.modalProducts;
          if (singleVariant) {
            const fields = this.props?.reserveStockFields;
            let isExist = false;
            if (fields?.length > 0) {
              isExist = fields.find(field => field.variantId === product.variants[0].id)
            }
            return <div className='priceContainer' style={{ justifyContent: 'flex-end'}}>
              <Button 
                type={isExist ? "secondary" : "primary"} 
                onClick={() => {this.props.handleProductList(products, product.variants[0])}}
                disabled={isExist}
                style={{ width: 'fit-content' }}
              >
                {isExist ? 'Added' : 'Select'}
              </Button>
            </div>
          } else {
            return <div className='priceContainer' style={{ justifyContent: 'flex-end'}}>
              <Button type="primary" onClick={() => {this.handleRowExpansion(product.id)}} style={{ width: 'fit-content' }}>
                Expand
              </Button>
            </div>
          }
        }
      },
    },
  ]

  render() {
    const { intl } = this.props;
    return (
      <React.Fragment>
        {this.props.isMerchantDashboard === true ? 
          <React.Fragment>
            {this.state.loading ? (
              <Row type="flex" justify="space-around" align="middle">
                <Spin spinning={this.state.loading} tip="Loading Products"></Spin>
              </Row>
            ) : (
              <React.Fragment>
                <Row type="flex" justify="center" align="middle">
                  {/* {this.state.searchValue ? 
                    <Icon className="cross-icon-portal" style={{ color: "red" }} type="close" onClick={this.handleResetSearch} /> 
                    :  
                    null 
                  } */}
                  <Search
                    className='search-field'
                    placeholder="Search for a Product"
                    enterButton="Search"
                    value={this.state.searchValue}
                    onChange={this.handleSearchChange}
                    style={{
                      width: '100%',
                      margin: '0px',
                    }}
                  />
                </Row>
                <Divider />
                <Table
                  scroll={{ x:768 }}
                  rowKey={(record) => record.id}
                  columns={this.columns}
                  expandedRowRender={this.handleRowRander}
                  dataSource={this.state.modalProducts}
                  pagination={{ 
                    defaultPageSize: 5,
                    current: this.state.currentPage,
                    onChange: this.handlePageChange,
                  }}
                  expandedRowKeys={[this.state.expandedRowId]}
                  onExpand={(_,record)=>this.handleRowExpansion(record.id)}
                  rowClassName={(record) => {
                    if (record.variants.length === 1) return 'NotExpandible'
                  }}
                  locale={{
                    emptyText: (
                      <div className="flex-row flex-middle-xxs flex-center-xxs">
                        <div className="flex-col-xxs-12">
                          <IconTray size="md" />
                        </div>
                        <div>
                          <p className="TextBody TextBody--xxxs">No Data</p>
                        </div>
                      </div>
                    ),
                  }}
                />
              </React.Fragment>
            )}
          </React.Fragment>
          : 
          <React.Fragment>
            {this.props.visible && (
              <Modal
                title={<FormattedMessage
                  id="app.visitor.storeWide.title"
                  description="Title of Store Wide products modal"
                  defaultMessage="Products"
                />}
                visible={true}
                onCancel={this.props.hideProducts}
                width={730}
              >
                {this.state.loading ? (
                  <Row type="flex" justify="space-around" align="middle">
                    <Spin spinning={this.state.loading} tip="Loading Products"></Spin>
                  </Row>
                ) : (
                  <React.Fragment>
                    <Row type="flex" justify="center" align="middle">
                      <Search
                        className='search-field'
                        placeholder={intl.formatMessage({
                          id:"app.visitor.storeWide.search",
                          description:"Search store wide products",
                          defaultMessage:"Search for a Product",
                        })}
                        enterButton={intl.formatMessage({
                          id:"app.visitor.storeWide.searchBtn",
                          description:"Search Button for Store wide products",
                          defaultMessage:"Search",
                        })}
                        value={this.state.searchValue}
                        onChange={this.handleSearchChange}
                        style={{
                          width: '100%',
                        }}
                      />
                    </Row>
                    <Divider />
                    <Table
                      scroll={{ x:768 }}
                      rowKey={(record) => record.id}
                      columns={this.columns}
                      expandedRowRender={this.handleRowRander}
                      dataSource={this.state.modalProducts}
                      pagination={{ 
                        defaultPageSize: 5,
                        current: this.state.currentPage,
                        onChange: this.handlePageChange,
                      }}
                      expandedRowKeys={[this.state.expandedRowId]}
                      onExpand={(_,record)=>this.handleRowExpansion(record.id)}
                      rowClassName={(record) => {
                        if (record.variants.length === 1) return 'NotExpandible'
                      }}
                      locale={{
                        emptyText: (
                          <div className="flex-row flex-middle-xxs flex-center-xxs">
                            <div className="flex-col-xxs-12">
                              <IconTray size="md" />
                            </div>
                            <div>
                              <p className="TextBody TextBody--xxxs">No Data</p>
                            </div>
                          </div>
                        ),
                      }}
                    />
                  </React.Fragment>
                )}
              </Modal>
            )}
          </React.Fragment>
        }
      </React.Fragment>
    )
  }
}

export default StoreWideProducts
